import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Tooltip from "@mui/material/Tooltip";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";

export default function AlertDialog(props) {
  const { validerropen, setvaliderropen } = props;

  const handleClose = () => {
    setvaliderropen(false);
  };

  return (
    <div>
      <Dialog
        open={validerropen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Please Check the Windows Storage!
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Minimum Requirement for linux storage is 30.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Close dialog">
            <span>
              <Button onClick={handleClose} color="primary" autoFocus sx={{ borderRadius: '50px' }}>
                OK
              </Button>
            </span>
          </Tooltip>
        </DialogActions>
      </Dialog>
    </div>
  );
}
